import useBooking from "@hooks/useBooking"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"
import AppointmentDetails from "@components/Appointments/AppointmentDetails"

const ConfirmAndSend = ({
  appointmentDetails,
  setAppointmentStage,
  setAppointmentDetails,
}) => {
  const { handleCreateGoogleEvent, handleAddCalendarBooking } = useBooking()
  const { ownDetails } = useSelector((state) => {
    return state.profile
  })

  const { isAddCalendarBookingLoading, isCreateGoogleEventLoading } =
    useSelector((state) => state.booking)
  const navigate = useNavigate()

  const handleSendInvite = async () => {
    if (appointmentDetails?.location === "online") {
      const data = await handleCreateGoogleEvent({
        summary: "Orbsway:Google Meet Appointment",
        location: appointmentDetails?.location ?? "online",
        description: "Orbsway: Google Meet Appointment",
        startTime: appointmentDetails.startDateTime,
        endTime: appointmentDetails.endDateTime,
        attendees: [appointmentDetails.email, ownDetails?.details?.email],
      })
      if (data) {
        handleAddCalendarBooking({
          ...appointmentDetails,
          eventId: data.data.id,
        })
        navigate("/manage-appointment")
      }
    } else {
      handleAddCalendarBooking(appointmentDetails)
      navigate("/manage-appointment")
    }
  }

  const handleEdit = () => {
    setAppointmentDetails((previous) => {
      return { ...previous, startDateTime: "", endDateTime: "" }
    })
    setAppointmentStage(0)
  }

  return (
    <AppointmentDetails
      appointmentDetails={appointmentDetails}
      onEdit={handleEdit}
      onCancel={handleSendInvite}
      isCancelLoading={
        isAddCalendarBookingLoading || isCreateGoogleEventLoading
      }
      showEditButton={true}
    />
  )
}

export default ConfirmAndSend
